import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "less--sprite",
  "use": "less--sprite-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"less--sprite\">\n<path d=\"M4.5 7.33333H12.5V8.66667H4.5V7.33333Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol